import React, { useState } from 'react'
import { loremIpsum } from "react-lorem-ipsum"
import "./style.css"
import MenuCard from './MenuCard'
import Menu from './menuapi'
function Restaurent() {
    const[menuData,setMenuData]=useState(Menu)
   const filterItem=(category)=>{
const upadateList=Menu.filter((curElem)=>{
return curElem.category===category
})
setMenuData(upadateList)
   }
    return (
        <>
<nav className='navbar'>
<div className='btn-group'>
<button className='btn-group_item' onClick={()=>filterItem("breakfast")}>Breakfast</button>
<button className='btn-group_item'onClick={()=>filterItem("lunch")}>lunch</button>
<button className='btn-group_item' onClick={()=>filterItem("evening")}>Evening</button>
<button className='btn-group_item' onClick={()=>filterItem("dinner")}>Dinner</button>
<button className='btn-group_item' onClick={()=>setMenuData(Menu)}>All</button>
</div>
</nav>
         <MenuCard menuData={menuData}/> 
        </>
    )
}

export default Restaurent